import { Card, CardContent, CardHeader, CardTitle } from '@shared/components';
import type { HolderFieldKey, ResolvedHolder } from '../utils/holderResolution';

interface Props {
    holder: ResolvedHolder;
    /** Opens the Customer tab, where the full record and the change action live. */
    onViewCustomer: () => void;
}

const headingId = 'agreement-customer-brief-heading';

const BRIEF_FIELDS: HolderFieldKey[] = ['name', 'businessName', 'email', 'phone'];

/** The at-a-glance holder on Overview. Deliberately read-only and partial — the
 *  full record, the as-sold comparison and the change action are on Customer. */
export function AgreementCustomerBrief({ holder, onViewCustomer }: Props) {
    const fields = BRIEF_FIELDS.map((key) => holder.fields.find((field) => field.key === key)).filter(
        (field) => field?.current !== undefined,
    );

    return (
        <Card>
            <CardHeader className="flex items-center justify-between gap-4">
                <CardTitle>
                    <span id={headingId}>Customer</span>
                </CardTitle>
                <button
                    type="button"
                    onClick={onViewCustomer}
                    className="text-sm text-mp-link underline underline-offset-2"
                >
                    View customer
                </button>
            </CardHeader>
            <CardContent>
                <section aria-labelledby={headingId}>
                    {fields.length === 0 ? (
                        <p className="text-sm text-mp-muted">
                            No customer details were recorded on this agreement.
                        </p>
                    ) : (
                        <dl className="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2">
                            {fields.map((field) => (
                                <div key={field!.key}>
                                    <dt className="text-sm text-mp-muted">{field!.label}</dt>
                                    <dd className="text-sm font-medium text-mp-foreground">
                                        {field!.current}
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    )}
                </section>
            </CardContent>
        </Card>
    );
}
